export enum ParamsKeys {
    SUBSTANCE_ID = 'substanceId',
    INCLUDE = 'include',
    EXCLUDE = 'exclude',
    CHILD_DEPTH = 'childDepth',
    SORT_BY = 'sortBy',
    ACCEPT = 'Accept',
    CONTENT_TYPE = 'Content-type',
    WHERE_NAME_CONTAINS = 'whereNameContains',
    SUBSTANCE_ATTR_VALUES = 'substanceAttributeValues',
    ANALYTICAL_TEST_ITEM_ID = 'analyticalTestItemId',
    ADDITIONAL_ATTR_VAL_IDS = 'additionalSpecifiedAttributeValueIds',
    CALLER_CLASSIFICATION = 'callerClassification',
    SAMPLE_TYPE_ID = 'sampleTypeId',
    CART_QUANTITY = 'quantity',
    CART_AUTOPOPULATED_QUANTITY = 'autoPopulatedQty',
    TEST_REASON_ID = 'testReasonId',
    CRM_ACCOUNT_ID = 'crmAccountId',
    SEARCH = 'q',
    ORDER_BY = 'orderBy',
    ORGANIZATION_GROUP_IDS = 'organisationGroupIds',
    IS_CUSTOM_CATALOGUE = 'isCustomCatalogue',
    VERIFICATION = 'verification'
}

export enum ParamsValues {
    CATALOGUE_ITEMS = 'catalogueItems',
    CATEGORY_NAME = 'category.name',
    PRICES = 'prices',
    NO_PRICE = 'catalogueItemsWithNoPrice',
    NO_DESCENDANTS = 'categoryNodesWithNoDescendantItems',
    HAS_DESCENDANTS = 'hasDescendantCatalogueItems',
    CREATION_INSTANT = 'cartItem.creationInstant',
    CREATION_INSTANT_DESC = 'cartItem.creationInstant.desc',
    CREATION_GRP_INSTANT_DESC = 'cartItem.creationInstant.desc',
    SUBSTANCE_BY_RANK = 'substance.rank',
    CATALOGUE_ITEM_NAME_ASC = 'catalogueItem.name.asc',
    CATALOGUE_ITEM_NAME_DESC = 'catalogueItem.name.desc',
    CATALOGUE_ITEM_POPULARITY_DESC = 'catalogueItem.popularity.desc',
    CATALOGUE_RECOMMENDATATION_LEVEL = 'catalogueItem.recommendationLevel',
    SUBSTANCE_NAME = 'substance.name',
    CHILD_DEPTH = '1000',
    SUBSTANCE_ATTR_RANK = 'substanceAttribute.rank',
    SUBSTANCE_ATTR_NAME = 'substanceAttribute.name',
    SUBSTANCE_ATTR_VAL_RANK = 'substanceAttributeValue.rank',
    SUBSTANCE_ATTR_VAL_NAME = 'substanceAttributeValue.name',
    EXTENDED_INFO = 'extendedInfo',
    INTERNAL = 'INTERNAL',
    CART_GROUP_SUGGESTION_CREATION_INSTANT = 'cartItemGroupSuggestion.groupCreationInstant',
    CART_GROUP_TYPE = 'cartItemGroup.type',
    CART_GROUP_CREATION_INSTANT = 'cartItemGroup.creationInstant',
    TEST_REASON_NAME_ASC = 'testReason.name.asc',
    NAME = 'Name'
}

export enum HeadersEnum {
    ACCEPT_CATEGORY = 'application/vnd.hilllabs.category-node-list.v1+json,application/vnd.hilllabs.category-node.v1+json',
    ACCEPT_CART = 'application/vnd.hilllabs.cart.v1+json',
    ACCEPT_CONTACT = 'application/vnd.hilllabs.contact.v1+json',
    ACCEPT_ORGANISATION = 'application/vnd.hilllabs.organisation.v1+json',
    ACCEPT_ERROR = 'application/vnd.hilllabs.error.v1+json',
    CONTACT_MAPPING_CONTENT_TYPE = 'application/vnd.hilllabs.contact-mapping.v1+json',
    CONTENT_TYPE = 'application/vnd.hilllabs.order-header.v1+json',
    SAMPLE_TYPE_ATTRIBUTE_REQUEST_CONTENT_TYPE = 'application/vnd.hilllabs.sample-type-attribute-request.v1+json',
    ACCEPT_CATALOGUE_ITEM = 'application/vnd.hilllabs.single-catalogue-item.v1+json',
    ACCEPT_SUBSTANCE_LIST = 'application/vnd.hilllabs.substance-list.v1+json',
    ACCEPT_SUBSTANCE_NODE_LIST = 'application/vnd.hilllabs.substance-node-list.v1+json',
    ACCEPT_SUBSTANCE_NODE = 'application/vnd.hilllabs.substance-node.v1+json',
    ACCEPT_SUBSTANCE_LINEAGE = 'application/vnd.hilllabs.substance-lineage.v1+json',
    ACCEPT_CATALOGUE_ITEM_LIST = 'application/vnd.hilllabs.catalogue-item-list.v1+json',
    ACCEPT_SUBSTANCE_ATTR = 'application/vnd.hilllabs.attributes-for-substance-list.v1+json,application/vnd.hilllabs.error.v1+json',
    ACCEPT_SUBSTANCE_ATTR_VAL = 'application/vnd.hilllabs.values-for-substance-attribute-list.v1+json',
    ACCEPT_ATTR_VAL_FOR_ANALYTICAL_TEST = 'application/vnd.hilllabs.applicable-attribute-for-analytical-test-list.v1+json',
    ACCEPT_CART_GROUP_SUGGESTION_LIST = 'application/vnd.hilllabs.cart-item-group-suggestion-list.v1+json',
    ACCEPT_SAMPLE_TYPE_ATTRIBUTE = 'application/vnd.hilllabs.sample-type-attribute.v1+json',
    ACCEPT_TEST_REASON = 'application/vnd.hilllabs.test-reason-list.v1+json',
    ACCEPT_ADDRESS_SUGGESTIONS = 'application/vnd.hilllabs.address-list.v1+json',
    ACCEPT_EMPTY = 'application/vnd.hilllabs.empty.v1+json'
}

export enum RestURLsEnum {
    CATEGORY_BASE = '/sampling-supplies/categories',
    SUBSTANCE_BASE = '/catalogue/substance/',
    SAMPLE_TYPE_ATTRIBUTE = '/cart/sample-type-attribute',
    SUBSTANCE_ATTR_BASE = '/catalogue/substance-attribute/',
    SUBSTANCE_ANALYTICAL_TESTS = '/catalogue/substance/[ID]/analytical-tests',
    SUBSTANCE_ANALYTICAL_TEST_ATTR = '/catalogue/substance/[SUBSTANCE_ID]/applicable-values-for-analytical-test',
    CART_BASE = '/cart/',
    CONTACT_BASE = '/contact/',
    ACCOUNT_BASE = '/contact/account/',
    REGISTER = '/contact/register',
    CATALOGUE_ITEM = '/catalogue/item/',
    LINEAGE = '/lineage',
    DELIVERY_ADDRESS_SUGGESTIONS = '/delivery-address-suggestions',
    ENSURE_MAPPING_EXISTS = 'ensure-mapping-exists',
    JOB_SUMMARY = '/jobs/search',
    SUBSTANCES_BY_ORG_GROUP_IDS = '/substances/by-organisation-group-ids',
    SUBSTANCES = '/substances',
    CATALOGUE_ITEMS_BY_ORG_GROUP_IDS = '/catalogue-items/by-organisation-group-ids',
    RECOMMENDED_TESTS = '/recommended-tests',
    PAYMENTS = '/payments',
    SESSIONS = '/sessions'
}
